<script>
import questionIcon from '@/assets/images/icons/question.svg?inline'
import closeIcon from '@/assets/images/icons/close.svg?inline'

export default {
  name: 'tariff-conditions',
  components: {
    questionIcon,
    closeIcon
  },
  props: {
    ids: {
      type: Object,
      default: () => ({
        hotelId: null,
        accommodationSearchId: null,
        accommodationId: null
      })
    },
    meal: {
      type: String,
      default: '',
    },
    room: {
      type: Array,
      default: () => ([])
    },
    hotelIndex: {
      type: Number,
      required: true
    },
  },
  data: () => ({
    isModalActive: false
  }),
  computed: {
    tariffConditions() {
      return this.$store.getters['cart/getHotelTariffConditions'](this.hotelIndex)
    },
    isLoading() {
      return this.tariffConditions.isLoading
    },
    error() {
      return this.$store.getters['cart/getServiceModuleErrors'](`hotels.${this.hotelIndex}.tariffConditions`)
    }
  },
  methods: {
    showModal() {
      this.$store.dispatch('cart/getHotelTariffConditions', {
        ids: this.ids,
        hotelIndex: this.hotelIndex
      })
      this.isModalActive = true
    },
    hideModal() {
      this.$store.commit('cart/updateServiceModuleIsLoading', {
        status: true,
        target: `hotels.${this.hotelIndex}.tariffConditions`
      })

      this.isModalActive = false
    }
  }
}
</script>

<template>
  <div class="cart__hotel-control--tariff-conditions cart__tariff-conditions">
    <questionIcon
      fill="#55b7a1"
      class="cart__tariff-conditions--btn"
      @click="showModal"
    />
    <b-modal
      :active.sync="isModalActive"
      scroll="keep"
      :can-cancel="['escape', 'outside']"
      @close="hideModal"
    >
      <div class="card">
        <div
          class="modal__wrap card-content"
          :class="{ loading: isLoading }"
        >
          <b-loading
            :is-full-page="false"
            :active="isLoading"
          />
          <div
            v-if="!isLoading"
            class="modal__content"
          >
            <div class="modal__header">
              <h2>Условия тарифа</h2>
              <close-icon
                @click="hideModal"
              />
            </div>
            <div class="modal__content-item">
              <h2>Дополнительная информация</h2>
              <p>Питание: {{ meal }}</p>
              <p>
                Размещение:
                <span v-if="room.length === 1">
                  {{ room[0].name }}
                </span>
                <ul v-else>
                  <li
                    v-for="(item, index) in room"
                    :key="index"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </p>
              <p
                v-if="tariffConditions.additionalInfo"
              >
                {{ tariffConditions.additionalInfo }}
              </p>
            </div>
            <div
              v-if="tariffConditions.importantInfo.length"
              class="modal__content-item"
            >
              <h2>Важная информация поставщика</h2>
              <p
                v-for="(item, index) in tariffConditions.importantInfo"
                :key="`importantInfo_${index}`"
                v-html="item"
              />
            </div>
            <div
              v-if="tariffConditions.remarks.length"
              class="modal__content-item"
            >
              <h2>Ремарки поставщика</h2>
              <p
                v-for="(item, index) in tariffConditions.remarks"
                :key="`remarks_${index}`"
              >
                {{ item }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>